import { render, staticRenderFns } from "./FormThanks.vue?vue&type=template&id=0b0bc97c&scoped=true&"
import script from "./FormThanks.vue?vue&type=script&lang=js&"
export * from "./FormThanks.vue?vue&type=script&lang=js&"
import style0 from "./FormThanks.vue?vue&type=style&index=0&id=0b0bc97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0bc97c",
  null
  
)

export default component.exports